import { FC, SVGProps } from 'react'

const Dots: FC<{ id: string; type: 'stroke' | 'circle' } & SVGProps<SVGSVGElement>> = ({
  id,
  type,
  ...svgProps
}) => {
  switch (type) {
    case 'stroke':
      return (
        <svg width="100%" height="100%">
          <defs>
            <pattern id={id} x="0" y="0" width="20" height="20" patternUnits="userSpaceOnUse">
              <circle
                id="Ellipse_494"
                data-name="Ellipse 494"
                cx="3"
                cy="3"
                r="3"
                transform="translate(0.5 0.5)"
                fill="none"
                stroke="#0fa"
                strokeMiterlimit="10"
                strokeWidth="1"
              />
            </pattern>
          </defs>
          <rect x="0" y="0" width="100%" height="100%" fill={`url(#${id})`} />
        </svg>
      )

    default:
      return (
        // eslint-disable-next-line react/jsx-props-no-spreading
        <svg width="100%" height="100%" {...svgProps}>
          <defs>
            <pattern id={id} x="0" y="0" width="25" height="25" patternUnits="userSpaceOnUse">
              <circle cx="3" cy="3" r="3" fill="#fff" />
            </pattern>
          </defs>
          <rect x="0" y="0" width="100%" height="100%" fill={`url(#${id})`} />
        </svg>
      )
  }
}

export default Dots
